var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"population-view"},[_c('PopulationList',{attrs:{"url":_vm.url,"filter":_vm.filter},on:{"print":_vm.setPrint}}),_c('div',{staticClass:"detail"},[_c('router-view',{attrs:{"url":_vm.url,"filter":_vm.filter,"print":_vm.print}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }